"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchySearch = exports.SearchResults = exports.SearchBoxContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var React = __importStar(require("react"));
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.SearchBoxContainer = styled_components_1.default.div.attrs({
    className: 'tws-hierarchy-search-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tposition: relative;\n\tpadding: 20px 20px 0;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: 100%;\n\t}\n"], ["\n\tbackground-color: ", ";\n\tposition: relative;\n\tpadding: 20px 20px 0;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: 100%;\n\t}\n"])), globalVars_module_scss_1.default.secondaryBlue);
exports.SearchBoxContainer.displayName = 'SearchBoxContainer';
exports.SearchResults = styled_components_1.default.div.attrs({
    className: 'tws-hierarchy-search-results',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tz-index: ", ";\n\tborder-radius: ", ";\n\tposition: absolute;\n\tmin-width: 550px;\n\tbox-shadow: ", ";\n\tul {\n\t\tlist-style-type: none;\n\t\tpadding-left: 0;\n\t\tmax-height: 425px;\n\t\toverflow-y: auto;\n\t\tmargin-bottom: 0;\n\t}\n\tli {\n\t\theight: 46px;\n\t\tpadding: 16px 20px;\n\t\tborder-bottom: 1px solid #999999;\n\t\tline-height: 1;\n\t}\n\tli:hover {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t}\n\tli:first-child {\n\t\tborder-top-right-radius: ", ";\n\t\tborder-top-left-radius: ", ";\n\t}\n\tli:last-child {\n\t\tborder-bottom-right-radius: ", ";\n\t\tborder-bottom-left-radius: ", ";\n\t\tborder-bottom: 0;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: 100%;\n\t}\n"], ["\n\tbackground-color: ", ";\n\tz-index: ", ";\n\tborder-radius: ", ";\n\tposition: absolute;\n\tmin-width: 550px;\n\tbox-shadow: ", ";\n\tul {\n\t\tlist-style-type: none;\n\t\tpadding-left: 0;\n\t\tmax-height: 425px;\n\t\toverflow-y: auto;\n\t\tmargin-bottom: 0;\n\t}\n\tli {\n\t\theight: 46px;\n\t\tpadding: 16px 20px;\n\t\tborder-bottom: 1px solid #999999;\n\t\tline-height: 1;\n\t}\n\tli:hover {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t}\n\tli:first-child {\n\t\tborder-top-right-radius: ", ";\n\t\tborder-top-left-radius: ", ";\n\t}\n\tli:last-child {\n\t\tborder-bottom-right-radius: ", ";\n\t\tborder-bottom-left-radius: ", ";\n\t\tborder-bottom: 0;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: 100%;\n\t}\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.layer2, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.shadow1, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.borderRadius3);
exports.SearchResults.displayName = 'SearchResults';
var HierarchySearch = /** @class */ (function (_super) {
    __extends(HierarchySearch, _super);
    function HierarchySearch(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showResults: false,
        };
        _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
        _this.handleGetSearchResults = _this.handleGetSearchResults.bind(_this);
        _this.handleFetchMoreResults = _this.handleFetchMoreResults.bind(_this);
        _this.nodeRef = React.createRef();
        return _this;
    }
    HierarchySearch.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentClick);
    };
    HierarchySearch.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentClick);
    };
    HierarchySearch.prototype.render = function () {
        return (React.createElement(exports.SearchBoxContainer, { ref: this.nodeRef },
            this.props && this.props.searchResults && (React.createElement(aon_tws_common_ui_1.SearchBox, { callbackFunc: this.handleGetSearchResults, resultsCount: this.props.searchResults ? this.props.searchResults.length : 0, initialSearchText: this.props.searchText ? this.props.searchText : '' })),
            this.props && !this.props.searchResults && (React.createElement(aon_tws_common_ui_1.SearchBox, { callbackFunc: this.handleGetSearchResults, resultsCount: 0, initialSearchText: '' })),
            this.state.showResults && this.props.searchResults && this.props.searchResults.length > 0 && (React.createElement(exports.SearchResults, null,
                React.createElement("ul", null,
                    React.createElement(react_infinite_scroller_1.default, { pageStart: 0, loadMore: this.handleFetchMoreResults, hasMore: this.props.hasMoreResults, loader: React.createElement("span", { key: 0 }, "Loading more results..."), useWindow: false, threshold: 20 }, this.props.searchResults.map(function (result) {
                        return (React.createElement("li", { key: result.resultId, id: "hierarchy_search_result_".concat(result.resultId), "data-hierarchy-search-resultid": result.resultId }, result.resultText));
                    })))))));
    };
    HierarchySearch.prototype.handleGetSearchResults = function (searchText) {
        if (searchText) {
            this.setState({
                showResults: true,
            });
            this.props.getSearchResults(searchText);
        }
        else {
            this.setState({
                showResults: false,
            });
            this.props.resetSearchResults();
        }
    };
    HierarchySearch.prototype.handleFetchMoreResults = function () {
        if (!this.props.loading) {
            this.props.getSearchResults(this.props.searchText);
        }
    };
    HierarchySearch.prototype.handleDocumentClick = function (e) {
        if (!(this.nodeRef && this.nodeRef.current && e && e.target)) {
            return;
        }
        if (this.props.searchResults && this.props.searchResults.length > 0) {
            var liElement = e.target;
            var resultSpanElementId = 'data-hierarchy-search-resultid';
            if (liElement.hasAttribute && liElement.hasAttribute(resultSpanElementId)) {
                // Handle search result click
                var resultId = liElement.getAttribute(resultSpanElementId);
                if (resultId) {
                    this.props.selectSearchResult(resultId);
                }
                this.setState({
                    showResults: false,
                });
            }
            else {
                if (this.nodeRef.current.contains(e.target) && !this.state.showResults) {
                    // Show search results when clicked on SearchBox
                    this.setState({
                        showResults: true,
                    });
                }
                else if (!this.nodeRef.current.contains(e.target) && this.state.showResults) {
                    // Hide search results when clicked on anywhere else on the page
                    this.setState({
                        showResults: false,
                    });
                }
            }
        }
    };
    return HierarchySearch;
}(React.PureComponent));
exports.HierarchySearch = HierarchySearch;
var templateObject_1, templateObject_2;
